/**
 * Chess analysis constants for the client-side Stockfish pipeline.
 * These mirror the backend constants in apps/backend/src/app/constants/analysis.ts.
 */
export const BLUNDER_THRESHOLD_CP = 200;
export const MISTAKE_THRESHOLD_CP = 100;
export const IMPRECISION_THRESHOLD_CP = 50;

export const PRESET_ICON_OFFSET: Record<string, string> = {
  quick: "-0.14em",
  balanced: "-0.12em",
  deep: "-0.11em",
};
